<template>
  <BasePage title="Resend Email Confirmation">
    <div class="columns">
      <div class="column is-8-tablet is-6-desktop is-offset-3-desktop is-offset-2-tablet is-one-third-fullhd is-offset-one-third-fullhd">
        <section class="mt-4">
          <h1 class="title is-2 mb-2">Email Confirmation Required</h1>
          <p>You need to confirm your email address before you can access all of the platform</p>
          <section class="d-flex justify-content-between flex-align-center mt-2">
            <button
              class="button is-primary"
              :class="loading && 'is-loading'"
              @click="resend()" >
              Resend Email
            </button>
          </section>
        </section>
      </div>
    </div>
  </BasePage>
</template>

<script>

import BasePage from './BasePage.vue'
import store from '../store'

import { resendEmailConfirmation } from '../actionTypes'

export default {
  name: 'ResendEmailConfirmation',
  data () {
    return {
      email: '',
      loading: false,
    }
  },
  components: {
    BasePage,
  },
  methods: {
    async resend () {
      this.loading = true
      try {
        await store.dispatch(resendEmailConfirmation)
      } catch (err) {}
      this.loading = false
    },
  },
}
</script>



// WEBPACK FOOTER //
// ResendEmailConfirmation.vue?26491966